import { getUserId, getUserToken } from '@ecomm/shared-cookies'
import * as TE from 'fp-ts/lib/TaskEither'
import { pipe } from 'fp-ts/lib/function'

import { fetchYodaApi } from './lib/fetchYodaApi'

export type Address = {
  readonly city: string
  readonly firstName: string
  readonly lastName: string
  readonly phone: string
  readonly state: string
  readonly street1: string
  readonly street2: string
  readonly zip: string
}

export type PaymentMethod = {
  readonly address: Address
  readonly ccType: string
  readonly expMonth: number
  readonly expYear: number
  readonly lastFour: string
  readonly paymentProfileId: string
  readonly paymentType: string
  readonly processor: string
}

export function isPaymentResponse(
  payments: unknown
): payments is readonly PaymentMethod[] {
  return !!payments && typeof payments === 'object'
}

export function fetchUserPaymentMethods(): TE.TaskEither<
  Error,
  never | readonly PaymentMethod[]
> {
  const userToken = getUserToken()
  const userId = getUserId()

  if (!userToken || !userId) {
    return TE.left(Error('User token or user ID is null or empty'))
  } else {
    return pipe(
      fetchYodaApi({
        endpoint: `/v1/users/${userId}/paymentMethods`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      }),
      TE.chain(res => (isPaymentResponse(res) ? TE.right(res) : TE.left(res))),
      TE.mapLeft(res => Error(`Error fetching payments for user: ${res}`))
    )
  }
}
